import type {FC} from 'react'
import {useEffect, useRef} from 'react'
import {useMutation} from 'react-query'
import {toast} from 'react-toastify'
import {useFormik} from 'formik'
import {InputDefault} from '../../ui'
import csvToJson from '../../../utils/csvToJson'
import {postImportRewards} from '../../../modules/services/rewards.service'
import {ModalDefault} from '../../ui'

interface Props {
  id: string
}

const ModalImportVoucher: FC<Props> = ({id}) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const mutation = useMutation(postImportRewards)

  const formik = useFormik({
    initialValues: {
      file: null as any,
      expiration_date: '',
    },
    onSubmit: ({file, expiration_date}) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = (e) => {
          const result = e.target?.result
          if (result) {
            const data = JSON.parse(
              file.type === 'text/csv' ? csvToJson(result as string) : (result as string)
            )
            mutation.mutate(
              {data: {data, expiration_date}, id},
              {
                onSuccess: () => {
                  toast.success('Import Success')
                  resolve({data, expiration_date, id})
                },
                onError(error: any, variables, context) {
                  console.log('Error', error.response?.data)
                  toast.error(error.response?.data?.error?.message)
                  reject(error)
                },
              }
            )
            formik.resetForm()
            inputRef.current!.value = ''
          }
        }
        reader.onerror = (e) => {
          console.log(e)
          reject(e)
        }
        reader.readAsText(file)
      })
    },
  })

  useEffect(() => {
    document.getElementById('import-modal-voucher')?.addEventListener('hidden.bs.modal', () => {
      formik.resetForm()
      inputRef.current!.value = ''
    })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <ModalDefault id='import-modal-voucher' title='Import Vouchers' hides={['footer']}>
      <form onSubmit={formik.handleSubmit}>
        <div className='d-flex flex-column align-items-center gap-4'>
          <div className='w-100'>
            <label htmlFor='import-upload-input' className='form-label'>
              Upload
            </label>
            <input
              ref={inputRef}
              type='file'
              id='import-upload-input'
              name='import-upload-input'
              className='form-control mb-6'
              onChange={(e) => {
                formik.setFieldValue('file', e.target.files![0])
              }}
            />
          </div>
          <div className='w-100'>
            <label htmlFor='expiration_date' className='form-label'>
              Expiration Date
            </label>
            <InputDefault
              type='date'
              name='expiration_date'
              value={formik.values.expiration_date}
              onChange={formik.handleChange}
              className='form-control mb-6'
              placeholder='Expiration Date'
            />
          </div>
        </div>
        <div className='d-flex justify-content-end gap-4'>
          <button type='button' id='close-modal' className='btn btn-light' data-bs-dismiss='modal'>
            Cancel
          </button>
          <button disabled={formik.isSubmitting} type='submit' className='btn btn-primary'>
            Submit
          </button>
        </div>
      </form>
    </ModalDefault>
  )
}

export default ModalImportVoucher
